import { render, staticRenderFns } from "./ProductSimulator.vue?vue&type=template&id=22bdb3dd&scoped=true"
import script from "./ProductSimulator.vue?vue&type=script&lang=js"
export * from "./ProductSimulator.vue?vue&type=script&lang=js"
import style0 from "./ProductSimulator.vue?vue&type=style&index=0&id=22bdb3dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdb3dd",
  null
  
)

export default component.exports